// extracted by mini-css-extract-plugin
export default {"service":"ServiceItem_service__YEcB+","description":"ServiceItem_description__9YxLO"};